import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { StoreTrailerDetailsFetchProps } from 'types/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import { fetchStoreTrailers } from 'queries/trailer/fetchStoreTrailers'
import { stripInitialTAndLeadingZeroes } from 'utils/item-search'
import { IStoreTrailerDetailsResponse } from 'utils/api'

export function useStoreTrailerDetails({
    env,
    accessToken,
    location,
    moveId,
}: StoreTrailerDetailsFetchProps): IStoreTrailerDetailsResponse {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const simpleLocation = stripInitialTAndLeadingZeroes(location ?? '')
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.STORE_TRAILER_DETAILS, location, moveId],
        () =>
            fetchStoreTrailers({
                env,
                accessToken,
                location,
                dynamicSubPath: moveId,
                filters: {
                    store_id: simpleLocation,
                },
                trackEvent,
            }),
        {
            enabled: !!moveId,
            staleTime: 0,
            refetchInterval: tenMinutes,
            refetchIntervalInBackground: false,
            refetchOnWindowFocus: false,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
